/* eslint-disable camelcase */
/* eslint-disable react/jsx-props-no-spreading */
/* eslint-disable no-alert */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from 'react';
import { Router, Switch, Route, Redirect } from 'react-router-dom';
import { ConfigProvider } from 'antd';
import history from '../../routes/history';
import useChangeLanguage from '../hooks/useChangeLanguage';
import AuthService from '../../services/AuthService';
import LoadingSpinner from '../../components/common/LoadingSpinner';
import Login from '../../pages/mobile/welcome/Login';
import LoginPhone from '../../pages/mobile/welcome/LoginPhone';
import ForgotPassword from '../../pages/mobile/welcome/ForgotPassword';
import SignInMain from '../../pages/mobile/sign-in/SignInMain';
import SignInSelect from '../../pages/mobile/sign-in/SignInSelect';
import ProfileSelect from '../../pages/mobile/sign-in/ProfileSelect';
import HomeScreen from '../../pages/mobile/sign-in/HomeScreen';
import ReasonScreen from '../../pages/mobile/sign-in/ReasonScreen';
import HomeGuestScreen from '../../pages/mobile/sign-in/HomeGuestScreen';

import SendDoctorLayout from '../../layouts/mobile/SendDoctorLayout';
import MedicalHistoryLayout from '../../layouts/mobile/MedicalHistoryLayout';
import UserAccountLayout from '../../layouts/mobile/UserAccountLayout';
import SpeakDoctorLayout from '../../layouts/mobile/SpeakDoctorLayout';
import AppointmentLayout from '../../layouts/mobile/AppointmentLayout';
import KnowledgeBankLayout from '../../layouts/mobile/KnowledgeBankLayout';
import SignupLoggedInLayout from '../../layouts/mobile/SignupLoggedInLayout';
import SignupGuestLayout from '../../layouts/mobile/SignupGuestLayout';
import SignupLayout from '../../layouts/mobile/SignupLayout';
import SignUpMethodScreen from '../../pages/mobile/sign-up/guest/SignUpMethodScreen';
import ReferralLayout from '../../layouts/mobile/ReferralLayout';
import FeedbackLayout from '../../layouts/mobile/FeedbackLayout';
import PrivateRoute from '../../routes/PrivateRoute';
import PublicRoute from '../../routes/PublicRoute';

const auth = new AuthService();

function MobileRoutesContainer() {
  const [currentAuthState, setCurrentAuthState] = useState('');

  const { lang, direction, changeLanguage } = useChangeLanguage();

  useEffect(() => {
    changeLanguage(lang, direction);
  }, []);

  const handleAuthentication = (nextState) => {
    if (
      /access_token|id_token|error/.test(nextState.location.hash) &&
      !currentAuthState
    ) {
      setCurrentAuthState(nextState);
      auth.handleAuthentication();
    }
  };

  return (
    <ConfigProvider /* locale={} */ direction={direction}>
      <div className="mobile-container">
        <div id="mobile-device">
          <Router history={history}>
            <Switch>
              <Route
                exact
                path="/callback"
                render={(props) => {
                  handleAuthentication(props);
                  return <LoadingSpinner position="full" />;
                }}
              />
              <PublicRoute exact path='/sign-in'>
                <SignInMain />
              </PublicRoute>
              <PublicRoute exact path='/login'>
                <Login />
              </PublicRoute>
              <PublicRoute exact path='/login-phone'>
                <LoginPhone />
              </PublicRoute>
              <PublicRoute exact path="/sign-in-select">
                <SignInSelect />
              </PublicRoute>
              <PublicRoute path="/sign-up/form">
                <SignupLayout />
              </PublicRoute>
              <PublicRoute path="/sign-up/guest/method">
                <SignUpMethodScreen />
              </PublicRoute>
              <PublicRoute path="/sign-up/loggedin">
                <SignupLoggedInLayout />
              </PublicRoute>
              <PublicRoute path="/sign-up/guest">
                <SignupGuestLayout />
              </PublicRoute>
              <PublicRoute path="/homepage-guest">
                <HomeGuestScreen />
              </PublicRoute>
              <PublicRoute path="/reason">
                <ReasonScreen />
              </PublicRoute>
              <PublicRoute path="/knowledge-bank">
                <KnowledgeBankLayout />
              </PublicRoute>
              <PrivateRoute path="/profile">
                <ProfileSelect />
              </PrivateRoute>
              <PrivateRoute path="/homepage">
                <HomeScreen />
              </PrivateRoute>
              <PrivateRoute path="/medical-history">
                <MedicalHistoryLayout />
              </PrivateRoute>
              <PrivateRoute path="/user-account">
                <UserAccountLayout />
              </PrivateRoute>
              <PublicRoute path="/speak-doctor">
                <SpeakDoctorLayout />
              </PublicRoute>
              <PrivateRoute path="/appointment">
                <AppointmentLayout />
              </PrivateRoute>
              <PrivateRoute path="/referral">
                <ReferralLayout />
              </PrivateRoute>
              <PrivateRoute path="/feedback">
                <FeedbackLayout />
              </PrivateRoute>
              <PublicRoute exact path="/forgot-password">
                <ForgotPassword />
              </PublicRoute>
              <PrivateRoute path="/send-doctor">
                <SendDoctorLayout />
              </PrivateRoute>
              <Redirect to='/sign-in' />
            </Switch>
          </Router>
        </div>
      </div>
    </ConfigProvider>
  );
}

export default MobileRoutesContainer;
